export const KINERJA_PS_PERENCANAAN_PERILAKU_KERJA_DRAFT_STORAGE_KEY =
  'kinerja-ps-perencanaan-perilaku-kerja-draft'
